module.exports = __webpack_public_path__ + "static/media/tennis-inplay.2e27f831.pdf";